'use client';
import { Tabs } from './tabs.js';
import { TabsList } from './tabs-list.js';
import { TabsPanel } from './tabs-panel.js';
import { TabsTab } from './tabs-tab.js';

/**
 * Display a group of tabs that can be toggled between.
 *
 * @example
 * <Tabs onChange={(value) => console.log(value)}>
 *   <Tabs.List>
 *     <Tabs.Tab value='1'>Tab 1</Tabs.Tab>
 *     <Tabs.Tab value='2'>Tab 2</Tabs.Tab>
 *     <Tabs.Tab value='3'>Tab 3</Tabs.Tab>
 *   </Tabs.List>
 *   <Tabs.Panel value='1'>content 1</Tabs.Panel>
 *   <Tabs.Panel value='2'>content 2</Tabs.Panel>
 *   <Tabs.Panel value='3'>content 3</Tabs.Panel>
 * </Tabs>
 */
const TabsComponent = Object.assign(Tabs, {
    List: TabsList,
    Tab: TabsTab,
    Panel: TabsPanel,
});
TabsComponent.Tab.displayName = 'Tabs.Tab';
TabsComponent.List.displayName = 'Tabs.List';
TabsComponent.Panel.displayName = 'Tabs.Panel';

export { TabsComponent as Tabs, TabsList, TabsPanel, TabsTab };
